import React              from 'react';
import { UseQueryResult } from 'react-query';
import { IFamilyMember }  from './withAuthorization';

const AuthorizationContext = React.createContext<UseQueryResult<IFamilyMember> | undefined>({} as UseQueryResult<IFamilyMember>);

export const AuthorizationProvider = AuthorizationContext.Provider;

export default AuthorizationContext;
